// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import * as React from 'react';
import { Modal, Icon } from 'office-ui-fabric-react';
import Styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
interface DeviceSDTRunDetail {
    testResults?: { key: any; value: any; }[];
}
export default function SDTResultsModal(props: DeviceSDTRunDetail) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const {
        testResults = [],
    } = props;

    function displayModal(event: any) {
        setShowModal(true);
        event.preventDefault();
        return false;
    }

    function closeModal(event: any) {
        setShowModal(false);
        event.preventDefault();
        return false;
    }

    function capitalize(str: string) {
        return str !== undefined && str !== null && str !== '' ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    }

    return (
        <div className={Styles.dvDisplayResult}>
            <a href="#" role="button" className={Styles.modalIcon} aria-label="Display SDT Results" onClick={displayModal} tabIndex={0}>
                <Icon iconName="FileSymLink" />
            </a>
            <Modal isOpen={showModal} isBlocking={false} onDismiss={closeModal}>
                <div className={Styles.dvModal}>
                    <div className={Styles.dvModalHeader}>
                        <span>{t('last_sdt_modal_header_text')}</span>
                        <a href="#" role="button" className={Styles.modalCloseIcon} aria-label="Close SDT Results" onClick={closeModal} >
                            <Icon iconName="Cancel" />
                        </a>
                    </div>
                    <div className={Styles.dvModalBody}>
                        <table className={Styles.tableNonBordered} role="grid">
                            <thead>
                                <tr role="row">
                                    <th role="columnheader" aria-label="Test Run"  className={Styles.tdTestRunName}>{t('last_sdt_modal_testrun_column_name')}</th>
                                    <th role="columnheader" aria-label="Test Result">{t('last_sdt_modal_testresult_column_name')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {testResults.map((element, index) => (
                                    <tr key={index} role="row">
                                        <td role="gridcell" className={Styles.tdTestRunName}>{capitalize(element.key)}</td>
                                        <td role="gridcell" className={element.value.toLowerCase() === 'succeeded' ? Styles.success : Styles.error}>{element.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
